export const MEDICATION_FREQUENCY_OPTIONS = [
  "Once a day",
  "Twice a day",
  "Three times a day",
  "Four times a day",
  "Every other day",
  "Every 2 hours",
  "Every 4 hours",
  "Every 6 hours",
  "Every 8 hours",
  "Every 12 hours",
  "Every 2 hours As needed",
  "Every 4 hours As needed",
  "Every 6 hours As needed",
  "Every 8 hours As needed",
  "Every 12 hours As needed",
] as const;
